import useSWR, { SWRConfiguration } from 'swr';
import hash from 'object-hash';
import { AxiosError } from 'axios';
import { PaginatedResult, PaginationParams } from '../../../providers/pagination';
import { SWRCustomResponse } from '../../../hooks/types';
import { useMatchMutate } from '../../../utils/swr/swr';
import { API_FEEDBACKS_PATH } from '../../../providers/api/api';
import { getFeedbacks, GetFeedbacksFilters } from '../../../providers/api/feedback/feedbackProvider';
import { Feedback } from '../../../providers/api/dtos';

export default function useFeedbacks(
  filters?: GetFeedbacksFilters,
  pagination?: PaginationParams,
  options?: SWRConfiguration<PaginatedResult<Feedback>, AxiosError>,
): SWRCustomResponse<PaginatedResult<Feedback>> {
  const matchMutate = useMatchMutate();
  const key = [API_FEEDBACKS_PATH, hash({ ...(filters || {}), ...(pagination || {}) })];
  const result = useSWR(key, () => getFeedbacks(filters, pagination), options);

  return {
    ...result,
    mutate: () => matchMutate(API_FEEDBACKS_PATH),
  };
}
